import {
  AdminInterestEntity,
  AdminInterestValidator,
  AdminInterestsQuery,
  ListEntityV2,
  V2Prefix,
  endpoints,
} from '@seaters/constants';
import { api } from '../axios-instance';

const basePath = `${V2Prefix}/${endpoints.seatersAdmin}/${endpoints.interests}`;

export const fetchAdminInterests = (
  params: AdminInterestsQuery
): Promise<ListEntityV2<AdminInterestEntity>> => api.get(basePath, { params });

export const createAdminInterest = (
  body: AdminInterestValidator
): Promise<AdminInterestEntity> => api.post(basePath, body);

export const updateAdminInterest = (
  id: string,
  body: AdminInterestValidator
): Promise<AdminInterestEntity> => api.put(`${basePath}/${id}`, body);

export const archiveAdminInterest = (
  id: string
): Promise<AdminInterestEntity> =>
  api.delete(`${basePath}/${id}`);
